import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplatePagesMutation, UpdateTemplatePagesMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplatePagesDocument } from '@/graphql/generated/graphql';
export type TemplatePagesUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  Slug?: string
  Locale?: string
  Keywords?: string[]
  Title?: string
  Description?: string
  HtmlBody?: string
  OgTitle?: string | null
  OgDescription?: string | null
  OgImage?: string | null
  Published?: boolean
  Blocks?: string
}

export type UpdateTemplatePagesResponse = {
  data: {
    updateTemplatePages: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplatePage = () => {
  const mutation = useMutation({
    mutationKey: ['update-template-page'],
    mutationFn: (variables: TemplatePagesUpdateInput) => {
      return graphqlClient.request<UpdateTemplatePagesMutation>(UpdateTemplatePagesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplatePage: mutation.mutate,
    updateTemplatePageAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_PAGE_MUTATION = UpdateTemplatePagesDocument;
